/**
 * EAS Logo – transitions to bottom: 0 when within 200px of page bottom
 *
 * @package oska
 */

export default function initEasLogo() {
  const logo = document.querySelector(".js-eas-logo");
  if (!logo) return;

  function onScroll() {
    const scrollBottom =
      document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
    logo.style.bottom = scrollBottom < 200 ? "0px" : "";
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}
